import { DoctoFatura } from "app/_models/doctoFatura";

export class DocumentosSelecionados {
    UsuarioId: number;
    UsuarioIDeCargo: number;
    Documentos: DoctoFatura[];
}